import {useKeycloak} from '@react-keycloak/web';
// import Keycloak from 'keycloak-js';
import React, {useEffect} from 'react';
import {ConfigObjectType, StateId} from 'src/js/common';
import {cleanLocalStorage} from 'src/js/hooks';

interface OwnProps {
  children: React.ReactNode;
  config: ConfigObjectType;
  stateId: StateId;
}
type Props = OwnProps;

export const EnsureLoggedInContainer: React.FC<Props> = (props) => {
  const {children, config: _1, stateId: _2} = props;
  const {keycloak, initialized: _} = useKeycloak();
  useEffect(() => {
    if (!keycloak?.authenticated) cleanLocalStorage('/');
  }, [keycloak?.authenticated]);
  return keycloak && keycloak.authenticated ? <>{children}</> : null;
};
